import { StaffType } from '@/data';
import type { Staff, Pixel } from '@/data';
import type { Image3DPageData, Image3DRowData } from '@/data/sources';
import type { ImageDimensions } from '@/data/sources/Source';
import type { Image3DPageFormat, Image3DRowFormat } from '@/formats/UnitParser';

function newPageWithoutRows(
  page: Image3DPageFormat,
  resourcesUrl: string | undefined,
  dimensions: ImageDimensions,
): Image3DPageData {
  return {
    image: `${resourcesUrl}${page.image}`,
    height: dimensions.height,
    width: dimensions.width,
    rows: [],
  };
}

function parseStaves(row: Image3DRowFormat): Staff[] {
  return row.staves?.map((s, index) => ({
    top: s.top as Pixel,
    bottom: s.bottom as Pixel,
    height: s.bottom - s.top as Pixel,
    id: index + 1,
    type: StaffType.staff,
    name: (index + 1).toString(),
  })) || [];
}

function newRowWithStaves(row: Image3DRowFormat): Image3DRowData {
  const parsedStaves: Staff[] = parseStaves(row);
  return {
    staves: [
      {
        top: row.y as Pixel,
        bottom: (row.y + row.height) as Pixel,
        height: row.height as Pixel,
        id: 0,
        type: StaffType.bar,
        name: 'all',
      },
      ...parsedStaves,
    ],
    y: row.y as Pixel,
    height: row.height as Pixel,
    end: row['end-x'] as Pixel,
    start: row['start-x'] as Pixel,
  };
}

export function pageToPageData(
  oldPage: Image3DPageFormat,
  dimensions: ImageDimensions,
  resourcesUrl?: string,
): Image3DPageData {
  const newPage: Image3DPageData = newPageWithoutRows(oldPage, resourcesUrl, dimensions);

  oldPage.rows.forEach((row) => {
    newPage.rows.push(newRowWithStaves(row));
  });

  return newPage;
}
